import { render, staticRenderFns } from "./AddressEditDialog.vue?vue&type=template&id=d9d5acba&scoped=true"
import script from "./AddressEditDialog.vue?vue&type=script&lang=js"
export * from "./AddressEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d5acba",
  null
  
)

export default component.exports